import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../app/store";
import { SxProps } from "@mui/system";
import { Theme } from "@mui/material/styles";

type ModalSlice = {
  show: boolean;
  hideCloseButton: boolean;
  content?: JSX.Element;
  boxStyle?: SxProps<Theme>;
  title?: string;
};

const initialState: ModalSlice = {
  show: false,
  hideCloseButton: false,
  content: undefined,
  boxStyle: undefined,
  title: undefined
};

export const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    setShowModal: (state, action: PayloadAction<boolean>) => {
      state.show = action.payload;
    },
    setHideModalCloseButton: (state, action: PayloadAction<boolean>) => {
      state.hideCloseButton = action.payload;
    },
    setModalContent: (
      state,
      action: PayloadAction<JSX.Element | undefined>
    ) => {
      state.content = action.payload;
      state.boxStyle = undefined;
      state.title = undefined;
    },
    setModalBoxStyle: (
      state,
      action: PayloadAction<SxProps<Theme> | undefined>
    ) => {
      state.boxStyle = action.payload;
    },
    setModalTitle: (state, action: PayloadAction<string | undefined>) => {
      state.title = action.payload;
    }
  }
});

export const {
  setShowModal,
  setModalContent,
  setHideModalCloseButton,
  setModalBoxStyle,
  setModalTitle
} = modalSlice.actions;
export const selectModalShow = (state: RootState) => state.modal.show;
export const selectModalContent = (state: RootState) => state.modal.content;
export const selectModalBoxStyle = (state: RootState) => state.modal.boxStyle;
export const selectModalTitle = (state: RootState) => state.modal.title;
export const selectModalHideCloseButton = (state: RootState) =>
  state.modal.hideCloseButton;

export default modalSlice.reducer;
